// Presentacion de creditos historicos migrados (origen distinto de ORIGINADO_MIDAS).
// Su "producto" del catalogo es un MARCADOR, no el producto original; frecuencia y condiciones solo se muestran
// cuando salen de sus datos historicos. La API marca `productoReferencial: true` en esos creditos.

export const PRODUCTO_HISTORICO_NO_IDENTIFICADO = 'Producto histórico no identificado';
export const FRECUENCIA_NO_DETERMINADA = 'No determinada';
export const NO_DISPONIBLE = 'No disponible';

export const esHistorico = (credito) => Boolean(credito && credito.productoReferencial);

export function etiquetaProducto(credito) {
  if (esHistorico(credito)) return PRODUCTO_HISTORICO_NO_IDENTIFICADO;
  return credito?.producto?.legacyName || credito?.producto?.nombre || '—';
}

// En historicos: solo el intervalo de su calendario; sin intervalo medible, "No determinada" (nunca por defecto).
export function etiquetaFrecuencia(credito, porDefecto = '—') {
  if (credito?.frecuencia) return credito.frecuencia;
  return esHistorico(credito) ? FRECUENCIA_NO_DETERMINADA : porDefecto;
}

// Detalle de la frecuencia de un historico: es OBSERVADA del calendario, no la modalidad contractual.
// Un promedio cercano a 14 dias no distingue catorcenal de quincenal de fechas fijas.
export function detalleFrecuenciaObservada(credito) {
  if (!esHistorico(credito) || !credito.frecuencia) return '';
  const partes = [];
  if (credito.intervaloPromedioDias != null) partes.push(`≈${credito.intervaloPromedioDias} días entre cuotas`);
  partes.push(credito.modalidadAmbigua ? 'modalidad no confirmada (≈14 días)' : 'modalidad contractual no certificada');
  return ` (${partes.join(' · ')})`;
}

export const rotuloFrecuencia = (credito, normal) => (esHistorico(credito) ? `${normal} OBSERVADA` : normal);
